export interface IAzureAdRegistration {
    id: number;
    name: string;
}

export interface IUserIdentity {
    emailAddress: string;
    name: string;
}

export interface IUser {
    id?: number;
    uniqueName: string;
    fullName: string;
    roleNames: string[];
}


export class User implements IUser {
    id: number;
    uniqueName: string;
    fullName: string;
    roleNames: string[];

    constructor(data: IUser) {
        this.id = data.id;
        this.uniqueName = data.uniqueName;
        this.fullName = data.fullName;
        this.roleNames = data.roleNames;
    }
}
